import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    intervals: Array,
    chapter: { type: Number, default: 1 }
  }

  static targets = ["link"]

  connect() { 
    // console.log('Kaltura controller connected'); 
    // console.log(kWidget);
    
    this.startVideoMonitoring();
    
    // Listen for tab changes to seek to the corresponding chapter
    this.element.addEventListener('tabs:chapter-change', this.handleTabChange.bind(this));
  }

  disconnect() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  
  // Helper method to highlight an element (replaces jQuery highlight)
  highlight(element) {
    if (!element) return;
    const originalBackground = element.style.backgroundColor;
    element.style.backgroundColor = '#ffff9c';
    setTimeout(() => {
      element.style.backgroundColor = originalBackground;
    }, 1500);
  }
  
  startVideoMonitoring() {
    this.intervalId = setInterval(() => {
      kWidget.addReadyCallback((playerId) => {
        const kdp = document.getElementById(playerId);
        this.checkChapter(Math.round(kdp.evaluate('{video.player.currentTime}')));      
        // console.log(kdp.evaluate('{video.player.currentTime}'));
      });
    }, 2000);
  }

  checkChapter(time) {
    const intervalWarningEl = document.querySelector('.mqi_interval_warning');
    const intervals = intervalWarningEl ? JSON.parse(intervalWarningEl.dataset.intervals || '[]') : [];
    
    let intervalSet = '';
    if (intervalWarningEl && intervalWarningEl.innerHTML) {
      const parts = intervalWarningEl.innerHTML.split(' ');
      intervalSet = parts.length > 3 ? parts[3].trim() : '';
    }
    
    // Get the tabs controller to determine the active tab
    const tabsController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="tabs"]'),
      'tabs'
    );
    
    let chapterHeadingTrimmed = '';
    let chapterSegmentTrimmed = '';
    
    if (tabsController) {
      const activeTabIndex = tabsController.index;
      const activeTab = tabsController.tabTargets[activeTabIndex];
      if (activeTab) {
        const linkEl = activeTab.querySelector('a');
        if (linkEl) {
          chapterHeadingTrimmed = (linkEl.dataset.chapter || '').trim();
          chapterSegmentTrimmed = (linkEl.dataset.segment || '').trim();
        }
      }
    }
    
    let changed = false;

    intervals.forEach((value, index) => {
      if (index == 0) { 
        if ((time >= 0 && time < value) && intervalSet != 1) {
          if (intervalWarningEl) {
            intervalWarningEl.innerHTML = 'Playhead in Chapter 1';
            this.highlight(intervalWarningEl);
            changed = true;
          }
        }
      } else {
        const start = index - 1;
        if ((time >= intervals[start] && time < value) && intervalSet != (index + 1)) {
          if (intervalWarningEl) {
            intervalWarningEl.innerHTML = 'Playhead in Chapter ' + (index + 1);
            this.highlight(intervalWarningEl);
            changed = true;
          }
        }
      }    
    });
    
    if (changed) {
      const togglePause = document.getElementById('toggle_pause');
      if (togglePause && togglePause.checked) {
        console.log('Pausing video due to chapter change');
        kWidget.addReadyCallback((playerId) => {
          const kdp = document.getElementById(playerId);
          kdp.sendNotification("pause");
        });
      }   
    }
    
    const mismatchElements = document.querySelectorAll('.chapter_mismatch');
    if ((intervalSet == chapterHeadingTrimmed) || (chapterHeadingTrimmed != 1 && chapterSegmentTrimmed == 0)) {
      mismatchElements.forEach(el => el.style.display = 'none');
    } else {
      mismatchElements.forEach(el => el.style.display = 'block');
    }  
  }

  chapterSeek(event) {
    event.preventDefault();
    
    // Get parameters from data attributes
    const time = parseInt(event.currentTarget.dataset.kalturaTimeParam);
    const c = parseInt(event.currentTarget.dataset.kalturaCParam);
    
    console.log('Seeking to ' + time);
    
    this.chapterValue = c;
    this.updateChapter();
    
    kWidget.addReadyCallback((playerId) => {
      const kdp = document.getElementById(playerId);
      kdp.sendNotification("mute");
      kdp.sendNotification("doSeek", time);
      kdp.sendNotification("unMute");
    });
  }

  nextChapter() {
    const nextChapterNum = this.chapterValue + 1;
    // Create synthetic event with dataset for chapterSeek
    const event = { 
      preventDefault: () => {},
      currentTarget: {
        dataset: {
          kalturaTimeParam: (nextChapterNum - 1) * 10,
          kalturaCParam: nextChapterNum
        }
      }
    };
    this.chapterSeek(event);
  }

  prevChapter() {
    const prevChapterNum = this.chapterValue - 1;
    // Create synthetic event with dataset for chapterSeek
    const event = { 
      preventDefault: () => {},
      currentTarget: {
        dataset: {
          kalturaTimeParam: (prevChapterNum - 1) * 10,
          kalturaCParam: prevChapterNum
        }
      }
    };
    this.chapterSeek(event);
  }
  
  // Handle tab change events from tabs controller
  handleTabChange(event) {
    if (event.detail && event.detail.segment !== undefined && event.detail.chapter !== undefined) {
      console.log(`Tab changed: Chapter ${event.detail.chapter}, Segment ${event.detail.segment}`);
      
      // Update the chapter value
      this.chapterValue = event.detail.chapter;
      
      // Seek to the segment time
      kWidget.addReadyCallback((playerId) => {
        const kdp = document.getElementById(playerId);
        kdp.sendNotification("doSeek", event.detail.segment);
      });
      
      // Update UI elements for the chapter
      this.updateChapter();
    }
  }
  
  // Helper method to activate a tab using the tabs_controller
  activateTab(chapterNum) {
    // Find the tabs controller instance
    const tabsController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller="tabs"]'),
      'tabs'
    );
    
    if (!tabsController) {
      console.error('Tabs controller not found');
      return;
    }
    
    // Find the tab index that corresponds to the chapter number
    // Assuming tabs are ordered by chapter position
    const tabIndex = tabsController.tabTargets.findIndex(tab => {
      const link = tab.querySelector('a');
      return link && parseInt(link.dataset.chapter) === chapterNum;
    });
    
    if (tabIndex !== -1) {
      // Set the index on the tabs controller to activate the tab
      tabsController.index = tabIndex;
    } else {
      console.warn(`No tab found for chapter ${chapterNum}`);
    }
  }

  updateChapter() {
    const preButton = document.getElementById('pre-button');
    if (preButton) {
      preButton.disabled = this.chapterValue == 1;
    }
    
    // Remove active class from all circles
    const circles = document.querySelectorAll('.number-circle');
    circles.forEach(circle => {
      circle.classList.remove('active_circle');
    });
    
    // Add active class to current chapter circle
    const activeCircle = document.getElementById('circle-id-' + this.chapterValue);
    if (activeCircle) {
      activeCircle.classList.add('active_circle');
    }
    
    // Update chapter numbers displayed
    const chapterNumElements = document.querySelectorAll('.chapter_num');
    chapterNumElements.forEach(el => {
      el.innerHTML = this.chapterValue;
    });
    
    // Activate the appropriate tab based on chapter number
    this.activateTab(this.chapterValue);
  }
}